import {
  Channel,
  EscalationInterface,
  EscalationStatus,
  EscalationUpdatedReturnData,
  EscalationsGroupInterface,
  SessionInterface,
  Slug
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// Controllers used:

// Controllers used:
// LINK apps/server/src/API/Escalations/Escalations.Controller.ts
// Groups:
// LINK apps/server/src/API/Escalations/Group/EscalationGroup.Controller.ts

export class EscalationsAPI {
  static async createEscalation(orgId: number, sessionId: number, slug: Slug) {
    return APIService.Server.post(`/escalations/org/${orgId}/session/${sessionId}/slug/${slug}`);
  }

  static async getEscalationsForAgent(orgId: number, memberId: number) {
    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/member/${memberId}`);
  }

  static async getEscalationsForUser(orgId: number, userId: number) {
    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/user/${userId}`);
  }

  static async getEscalationGroups(orgId: number) {
    return APIService.Server.get<EscalationsGroupInterface[]>(`/escalation-groups/org/${orgId}`);
  }

  static async getAllEscalations(orgId: number, limit: number, skip: number) {
    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/all`, { limit, skip });
  }

  static async getAllActiveEscalations(orgId: number) {
    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/active`);
  }
  static async getUnacknowledgedEscalations(orgId: number, memberId: number) {
    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/unacknowledged-by/${memberId}`);
  }

  static async searchForEscalations(
    orgId: number,
    statusesParam?: EscalationStatus[],
    limit?: number,
    skip?: number,
    searchQuery?: string,
    agentIds?: number[] //TODO: NickG to implement
  ) {
    let params: any = { statuses: statusesParam, limit, skip, searchQuery, agentIds };
    // delete empty params

    Object.keys(params).forEach((key: any) => params[key] === undefined && delete params[key]);
    if (!params.skip || isNaN(params.skip)) {
      params.skip = 0;
    }

    return APIService.Server.get<EscalationInterface[]>(`/escalations/org/${orgId}/search`, params);
  }

  static async createEscalationGroup(orgId: number, group: Partial<EscalationsGroupInterface>) {
    return APIService.Server.post<EscalationsGroupInterface>(`/escalation-groups/org/${orgId}`, group);
  }

  static async updateEscalationGroup(orgId: number, groupId: number, group: Partial<EscalationsGroupInterface>) {
    return APIService.Server.put<EscalationsGroupInterface>(`/escalation-groups/org/${orgId}/group/${groupId}`, group);
  }

  static async deleteEscalationGroup(orgId: number, groupId: number) {
    return APIService.Server.delete(`/escalation-groups/org/${orgId}/group/${groupId}`);
  }

  static async acceptEscalation(orgId: number, sessionId: number, escalationId: number, memberId: number) {
    return APIService.Server.put<EscalationUpdatedReturnData>(
      `/escalations/org/${orgId}/session/${sessionId}/escalation/${escalationId}/member/${memberId}/accept`
    );
  }

  static async rejectEscalation(orgId: number, sessionId: number, escalationId: number, memberId: number) {
    return APIService.Server.put<EscalationUpdatedReturnData>(
      `/escalations/org/${orgId}/session/${sessionId}/escalation/${escalationId}/member/${memberId}/reject`
    );
  }

  static async acknowledgeEscalation(orgId: number, sessionId: number, escalationId: number, memberId: number) {
    return APIService.Server.put<EscalationUpdatedReturnData>(
      `/escalations/org/${orgId}/session/${sessionId}/escalation/${escalationId}/acknowledged-by/${memberId}`
    );
  }

  static async generateSummaryForEscalation(orgId: number, escalationId: number) {
    return APIService.Server.get<string>(`/escalations/org/${orgId}/escalation/${escalationId}/generate-summary`);
  }

  static async startOutboundVoiceEscalation(orgId: number, userId: number, memberId: number) {
    return APIService.Server.put<SessionInterface>(`/escalations/call/outbound`, { orgId, userId, memberId });
  }

  static async endVoiceEscalationByCallSid(callSid: string) {
    return APIService.Server.put<SessionInterface>(`/escalations/call/${callSid}/close`);
  }

  static async listenIn(orgId: number, twilioToken: string, sessionId: number, escalationId: number) {
    return APIService.Server.post<{ roomName: string }>(`/escalations/call/listen-in`, {
      orgId: orgId,
      twilioToken: twilioToken,
      sessionId: sessionId,
      escalationId: escalationId
    });
  }
}
